import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import CSSModules from 'react-css-modules';

import Translate from '@client/components/shared/translation/Translate';
import { track } from '@client/helpers/tracking';
import { SEC_SUB_SUCCESS_PLACEMENT } from '@client/config/constants';

import InfoBox from '../../../shared/InfoBox';

import { getStep } from './helper';
import styles from './styles.scss';

export class SecondarySubscriptionMessage extends PureComponent {
    static propTypes = {
        reject: PropTypes.func.isRequired,
        subscribe: PropTypes.func.isRequired,
        confirmEmail: PropTypes.func,
        close: PropTypes.func.isRequired,
        rejected: PropTypes.bool.isRequired,
        acccepted: PropTypes.bool.isRequired,
        error: PropTypes.bool.isRequired,
        pending: PropTypes.bool.isRequired,
        hasOrders: PropTypes.bool.isRequired,
        isDoi: PropTypes.bool.isRequired,
        isCucaHelpShown: PropTypes.bool.isRequired,
        placement: PropTypes.string,
    }

    render() {
        const {
            pending,
            close,
            step,
            placement
        } = this.props;

        const {
            onAccept,
            onReject,
            text,
            title,
            iconComponent,
            yesMessage = 'messageYes',
            noMessage = 'messageNo',
            placeholder = false
        } = step || {};
        const isSuccessPage = placement === SEC_SUB_SUCCESS_PLACEMENT;

        return (
            <div styleName="wrapper">
                <InfoBox
                    title={title}
                    iconComponent={iconComponent}
                    onCloseClick={close}
                    noCloseIcon={isSuccessPage}
                    inline={isSuccessPage}
                    pending={pending || !step}
                >
                    {step &&
                        <Fragment>
                            <div><Translate message={text} html /></div>
                            { placeholder && <div styleName="button-placeholder"></div>}
                            { onAccept && <div role="button" styleName="button primary" onClick={onAccept}><Translate message={yesMessage} html /></div> }
                            { onReject && <div role="button" styleName="button secondary" onClick={onReject}><Translate message={noMessage} html /></div> }
                        </Fragment>
                    }
                </InfoBox>
            </div>
        );
    }

    componentDidUpdate(prevProps) {
        const { step, isCucaHelpShown } = this.props;
        if (!step) {
            return;
        }

        if (prevProps.step.id !== step.id || prevProps.isCucaHelpShown !== isCucaHelpShown) {
            track(`secondary_subscription_${step.id}_view`);
        }
    }
}

const mapStateToProps = (_state, ownProps) => ({
    step: getStep(ownProps)
});

export const injectStyles = component => CSSModules(component, styles, { allowMultiple: true });

export default compose(
    connect(mapStateToProps),
    injectStyles,
)(SecondarySubscriptionMessage);
